import { formatDynamicFields } from 'utils/graphqlUtils'

export const fieldsByQuery = {
  MissingCopilotSettingsQuery: `
    id
    patientId
    program
    statusKey
    name
    profilePicture { key bucket region }
  `,
  NeedsAttentionPatientsQuery: `
    id
    program
    statusKey
    name
    needsAttentionReason
    needsAttentionTime
    profilePicture {
      key
      bucket
      region
    }
    patientTags {
      items {
        _deleted
        createdAt
        metadata
        tag {
          value
        }
      }
    }
  `,
  PatientsSentimentQuery: `
    id
    program
    statusKey
    name
    profilePicture {
      key
      bucket
      region
    }
    patient {
      copilotData
    }
    lastMessageTimestamp
    copilotChatSentimentScore
  `,
  OralHygienePatientsQuery: `
    id
    program
    statusKey
    name
    profilePicture {
      key
      bucket
      region
    }
    lastOhScanDate
    lastHygieneScore
    lastDentalRisk
    lastPerioRisk
    hygieneTrend
  `,
  TxTrackingPatientsQuery: `
    id
    program
    statusKey
    name
    profilePicture {
      key
      bucket
      region
    }
    lastTrackedScanDate
    lastTrackStatus
    lastTrackingReasons
    recentTrackedScans
  `,
  PatientsScanningScoreQuery: `
    id
    program
    statusKey
    name
    profilePicture {
      key
      bucket
      region
    }
    patient {
      copilotData
    }
    lastGrinScanUploadDate
    lastMessageTimestamp
    copilotScanningScheduleScore
    copilotScanningScheduleScoreCategory
    currentCycleOriginalEndDate
  `
}

export const searchPatientSearchModels = fields => /* GraphQL */ `
  query SearchPatientSearchModels(
    $filter: SearchablePatientSearchModelFilterInput
    $sort: SearchablePatientSearchModelSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchPatientSearchModels(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      nextToken
      total
      items {
        ${formatDynamicFields(fields)}
      }
    }
  }
`

export const fetchTrackedScanTimelineItem = /* GraphQL */ `
  query FetchTrackedScanTimelineItem($patientId: ID!, $scanUniqueId: ID!) {
    searchTimelineItems(
      filter: { patientId: { eq: $patientId }, type: { eq: "grinScan" }, relatedEntityId: { eq: $scanUniqueId } }
      limit: 1
    ) {
      items {
        id
        payload
        eventDate
      }
    }
  }
`

export const fetchPatientCopilotData = /* GraphQL */ `
  query FetchPatientCopilotData($patientId: ID!) {
    getPatient(id: $patientId) {
      copilotData
    }
    searchTimelineItems(
      filter: { patientId: { eq: $patientId }, type: { eq: "grinScan" } }
      sort: { direction: desc, field: eventDate }
      limit: 3
    ) {
      items {
        id
        payload
        eventDate
      }
    }
  }
`

export const fetchPatientBriefCoverage = /* GraphQL */ `
  query FetchPatientBriefCoverage($filter: SearchablePatientSearchModelFilterInput!, $limit: Int, $nextToken: String) {
    searchPatientSearchModels(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sort: { field: id, direction: asc }
    ) {
      nextToken
      items {
        id
        hasPatientBrief
        _deleted
      }
    }
  }
`
